import { forwardRef } from 'react'
import { ReactSVG } from 'react-svg'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface ProductGroupMenuButtonProps {
  title: string
  onClick: () => void
  className?: string
  isActive?: boolean
}

export const ProductGroupMenuButton = forwardRef<HTMLButtonElement, ProductGroupMenuButtonProps>(
  ({ title, onClick, className, isActive = false }, ref) => {
    const iconSrc = isActive
      ? '/icons/categories-menu-active.svg'
      : '/icons/categories-menu-default.svg'

    return (
      <button
        ref={ref}
        className={cn(styles.productGroupMenuButton, className, {
          [styles.productGroupMenuButton_active]: isActive
        })}
        onClick={onClick}
        type="button"
      >
        <div className={styles.productGroupMenuButton__icon}>
          <ReactSVG
            src={iconSrc}
            className={styles.productGroupMenuButton__svg}
          />
        </div>
        <span className={styles.productGroupMenuButton__text}>{title}</span>
      </button>
    )
  }
)
